module.exports = __webpack_public_path__ + "img/iron.d536869b.jpeg";